import { Button } from "@/components/ui/button";
import React from "react";

interface PaginationButtonProps {
  children: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const PaginationButton: React.FC<PaginationButtonProps> = ({
  children,
  active,
  disabled,
  onClick,
}) => (
  <Button
    variant={active ? "outline" : "outline"}
    size="sm"
    disabled={disabled}
    onClick={onClick}
    className={`h-8 w-8 p-2 ${
      active
        ? "bg-blue-600 hover:bg-blue-400 text-white"
        : "hover:bg-blue-500 hover:text-white"
    }`}
  >
    <span className="flex items-center justify-center w-full h-full">
      {children}
    </span>
  </Button>
);

export default PaginationButton; 